<div>
    <ngx-slider [options]="options" [(value)]="minAge" [(highValue)]="maxAge"></ngx-slider>
    <div class="mat-hint mat-small">Hästar födda mellan {{ 2020 - maxAge }} och {{ 2020 - minAge }}</div>

</div>
